// extracted by mini-css-extract-plugin
module.exports = {"link":"link__link___1FCfw","desktop":"link__desktop___21TJ5","arrow":"link__arrow___2TfFA","mobile":"link__mobile___3y0XI"};
    if(module.hot) {
      // 1665497109373
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  